import MainStage from 'Pages/MainStage';
import MainStageRemote from 'Pages/MainStage/RemoteControl';
import GettingReady from 'Pages/MainStage/GettingReady';
import TestStream from 'Pages/MainStage/TestStream';

import AdminMainStage from 'Pages/Admin/MainStage';
import AdminMainStageStore from 'Pages/Admin/MainStage/Store';
import AdminMainStageChat from 'Pages/Admin/MainStage/Chat';
import AdminMainStageReactions from 'Pages/Admin/MainStage/Reactions';
import AdminMainStagePolls from 'Pages/Admin/MainStage/Polls';
import AdminMainStagePollsStore from 'Pages/Admin/MainStage/Polls/Store';
import AdminMainStagePollsResults from 'Pages/Admin/MainStage/Polls/Results';
import AdminMainStageQuestions from 'Pages/Admin/MainStage/Questions';
import AdminMainStageQuestionStore from 'Pages/Admin/MainStage/Questions/Store';
import AdminMainStageLivePollResults from 'Pages/Admin/MainStage/Polls/LiveResults';
import MainStageQuestions from "Pages/MainStage/MainStageQuestions";
import MainStageChat from "Pages/MainStage/MainStageChat";

export default [
    // Frontend
    { path: '/main-stage/join', component: require('Pages/MainStage/Join').default },
    { path: '/main-stage', component: MainStage },
    { path: '/main-stage/remote', component: MainStageRemote },
    { path: '/main-stage/questions', component: MainStageQuestions, guards: ['admin'] },
    { path: '/main-stage/chat', component: MainStageChat, guards: ['admin'] },

    { path: '/main-stage/getting-ready', component: GettingReady, guards: ['auth'] },
    { path: '/main-stage/test-stream', component: TestStream, guards: ['auth'] },

    // Admin
    { path: '/admin/main-stage', component: AdminMainStage, guards: ['admin'] },
    { path: '/admin/main-stage/store/:session?', component: AdminMainStageStore, guards: ['admin'] },
    { path: '/admin/main-stage/chat/:session', component: AdminMainStageChat, guards: ['admin'] },
    { path: '/admin/main-stage/reactions/:session', component: AdminMainStageReactions, guards: ['admin'] },
    { path: '/admin/main-stage/polls/live', component: AdminMainStageLivePollResults, guards: ['admin'] },
    { path: '/admin/main-stage/polls/:session', component: AdminMainStagePolls, guards: ['admin'] },
    { path: '/admin/main-stage/polls/:session/store/:poll?', component: AdminMainStagePollsStore, guards: ['admin'] },
    { path: '/admin/main-stage/polls/:session/results/:poll?', component: AdminMainStagePollsResults, guards: ['admin'] },
    { path: '/admin/main-stage/questions/:session', component: AdminMainStageQuestions, guards: ['admin'] },
    { path: '/admin/main-stage/questions/:session/store/:question', component: AdminMainStageQuestionStore, guards: ['admin'] },
];
